/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState } from "react";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Switch from "@mui/material/Switch";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import i18n from "components/Translation/Translate";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import * as Defi from "services/Define";
import { setToken, setUser, setLang, setPerm, setMenu, clearState } from "redux/actions/appAction";
import { PostData } from "services/Request";

// Authentication layout components

// Image
import bgImage from "assets/images/illustrations/illustration-lock.jpg";
import IllustrationLayout from "./components/IllustrationLayout";

function SignIn() {
  const mod = "authen";
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const app = useSelector((state) => state[Defi.APP_STATE]);
  const [rememberMe, setRememberMe] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const signIn = (event) => {
    event.preventDefault();

    dispatch(clearState());

    PostData(`/login`, {
      lang: app.lang,
      username: username,
      password: password,
    }).then((result) => {
      if (result.status === "ok") {
        dispatch(setToken(result.token));
        dispatch(setUser(result.user));
        dispatch(setMenu(result.menu));
        dispatch(setPerm(result.perm));
        dispatch(setLang(result.user.language));

        window.location.replace(result.url);
      }
    });
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);
    console.log(i18n);
    // console.log("SignIn", app);

    // register();
  }, []);

  return (
    <IllustrationLayout
      title="Sign In"
      description="Enter your username and password to sign in"
      illustration={bgImage}
    >
      <MDBox component="form" role="form" onSubmit={signIn}>
        <MDBox mb={2}>
          <MDInput
            name="user_name"
            type="text"
            label={t(`${mod}.username`)}
            fullWidth
            inputProps={{
              onChange: (event) => setUsername(event.target.value),
            }}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            name="user_pass"
            type="password"
            label={t(`${mod}.password`)}
            fullWidth
            inputProps={{
              onChange: (event) => setPassword(event.target.value),
              type: "password",
              autoComplete: "off",
            }}
          />
        </MDBox>
        <MDBox display="flex" alignItems="center" ml={-1}>
          <Switch checked={rememberMe} onChange={handleSetRememberMe} />
          <MDTypography
            variant="button"
            fontWeight="regular"
            color="text"
            onClick={handleSetRememberMe}
            sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
          >
            &nbsp;&nbsp;Remember me
          </MDTypography>
        </MDBox>
        <MDBox mt={4} mb={1}>
          <MDButton type="submit" variant="gradient" color="info" size="large" fullWidth>
            {t(`${mod}.signin`)}
          </MDButton>
        </MDBox>
      </MDBox>
    </IllustrationLayout>
  );
}

export default SignIn;
